export interface TenantFeatures {
  [key: string]: boolean;
}

export const TenantModule = {
  AadeMyData: 'aade_mydata',
  Storage: 'storage',
  Reporting: 'reporting',
  Billing: 'billing',
  Hr: 'hr',
  Requests: 'requests',
} as const;

export type TenantModule = (typeof TenantModule)[keyof typeof TenantModule];

export interface TenantTheme {
  primaryColor: string;
  logo: string;
  favicon?: string;
}

export interface TenantAuth {
  ssoEnabled: boolean;
  provider?: 'google' | 'azure' | 'okta' | string;
  mfaRequired?: boolean;
}

export interface TenantLimits {
  maxUsers: number;
  storageGb: number;
}

export interface TenantSettings {
  tenant: string;
  tenantId: number;
  displayName: string;
  features: TenantFeatures;
  theme?: TenantTheme;
  auth?: TenantAuth;
  limits?: TenantLimits;
  modules: TenantModule[];
  timezone?: string;
  locale?: string;
}
